<template>
    <Drawer v-model:visible="showHeaderDrawer" position="right" classes="!w-[45%] !bg-[#F0F0F0] chat-drawer automezzi-documenti-comuni-drawer">
        <div class="automezzi-documenti-comuni-drawer-shell">
            <div class="automezzi-documenti-comuni-drawer-header">
                <div v-if="headerDrawerTitle" class="automezzi-documenti-comuni-drawer-title">{{ headerDrawerTitle }}</div>
            </div>
            <div class="automezzi-documenti-comuni-drawer-content">
                <div v-if="headerDrawerLoading" class="automezzi-documenti-comuni-drawer-loading">
                    <i class="pi pi-spin pi-spinner"></i>
                </div>
                <div v-else v-html="headerDrawerHtml"></div>
            </div>
        </div>
    </Drawer>
    <Dialog v-model:visible="templateModalVisible" modal :header="templateModalTitle" :style="{width: '1140px', maxWidth: '95vw'}" :class="['template-modal-dialog', {'template-modal-dialog-cartella': templateModalIsCartella}]">
        <div v-if="!templateModalForm.struttura" class="flex justify-center py-6">
            <i class="pi pi-spin pi-spinner text-2xl text-gray-400"></i>
        </div>
        <FormInput
            v-else
            :key="templateModalFormKey"
            :dati="templateModalForm.dati"
            :formlabel="templateModalForm.struttura"
            idform="template-modal-form"
            stilestruttura="grid grid-cols-1 md:grid-cols-3 gap-x-3 gap-y-4 template-document-modal-grid"
            recaptcha=""
            :action="templateModalForm.action"
            ref="templateModalInput"
        />
        <template #footer>
            <div class="flex gap-3 w-full template-modal-footer">
                <button
                    type="button"
                    class="flex-1 flex items-center justify-center gap-2 text-sm transition-colors template-modal-cancel"
                    @click="closeTemplateModal"
                >
                    <i class="pi pi-times" style="font-size: 12px;"></i> Annulla
                </button>
                <button
                    type="button"
                    class="flex-1 flex items-center justify-center gap-2 text-white text-sm font-medium rounded transition-colors template-modal-save"
                    :disabled="templateModalSubmitting"
                    @click="$refs.templateModalInput && $refs.templateModalInput.checkForm(0)"
                >
                    <i :class="templateModalSubmitting ? 'pi pi-spin pi-spinner' : 'pi pi-check'" style="font-size: 12px;"></i> Salva
                </button>
            </div>
        </template>
    </Dialog>
    <Dialog v-model:visible="deleteTemplateModalVisible" modal
            :header="deleteTemplateModalIsCartella ? 'Elimina cartella' : 'Elimina documento'"
            :style="{width: '440px'}" class="template-modal-dialog">
        <div class="flex items-start gap-3 py-2">
            <i class="pi pi-exclamation-triangle" style="font-size:22px;color:#e67e22;margin-top:2px;flex-shrink:0;"></i>
            <div class="flex flex-col gap-2">
                <p class="text-sm text-gray-700">
                    Stai eliminando {{ deleteTemplateModalIsCartella ? 'questa cartella' : 'questo documento' }}
                    da <strong>tutti i veicoli</strong> in cui è presente.
                </p>
                <p v-if="deleteTemplateModalIsCartella && deleteTemplateModalChildrenCount > 0"
                   class="text-sm font-medium" style="color:#dc2626;">
                    <i class="pi pi-exclamation-circle" style="font-size:12px;"></i>
                    La cartella contiene <strong>{{ deleteTemplateModalChildrenCount }} elementi</strong>
                    che verranno eliminati insieme ad essa.
                </p>
            </div>
        </div>
        <template #footer>
            <div class="flex gap-3 w-full">
                <button type="button"
                        class="flex-1 flex items-center justify-center gap-2 text-sm text-gray-500 hover:text-gray-700 transition-colors"
                        style="padding:12px;"
                        @click="deleteTemplateModalVisible = false">
                    <i class="pi pi-times" style="font-size:12px;"></i> Annulla
                </button>
                <button type="button"
                        class="flex-1 flex items-center justify-center gap-2 text-white text-sm font-medium rounded transition-colors disabled:opacity-50"
                        style="padding:12px;background-color:#dc2626;white-space:nowrap;"
                        :disabled="deleteTemplateModalLoading"
                        @click="confirmDeleteTemplate">
                    <i :class="deleteTemplateModalLoading ? 'pi pi-spin pi-spinner' : 'pi pi-trash'" style="font-size:12px;"></i>
                    Elimina da tutti i veicoli
                </button>
            </div>
        </template>
    </Dialog>
    <DataTable v-model:filters="filters"
               class="app-datatable"
               :filterButtonProps="{ filter: { class: 'app-dt-filter-btn' } }"
               :value="rows"
               :size="datatableSize"
               filterDisplay="menu"
						 :loading="loading"
						 loadingIcon="pi pi-spin pi-spinner"
						 :lazy="is_lazy"
               removableSort
               :scrollable="!scroll_height || scroll_height !== 'none'"
               :scrollHeight="(!scroll_height || scroll_height === 'none') ? undefined : scroll_height"
               :rows=paginatorRows
               :paginator="paginatorEnabled"
               stateStorage="session" :stateKey="stateKey"
               :globalFilterFields="globalfilters">
        <template #header>
            <div class="flex justify-between container-button-e-search">
                <div class="icon-action-datatable-container">
                    <Button class="icon-action-datatable" text icon="pi pi-filter-slash" @click="clearFilter()"
                            v-tooltip.bottom="$root.trans.pulisci_filtri || 'Pulisci filtri'"/>
                    <Button v-if="add_action" as="a" class="icon-action-datatable" text icon="pi pi-plus"
                            :href="add_action"/>
                    <template v-for="(headerAction, index) in headerActions" :key="`header-action-${index}`">
                        <Button
                            v-if="headerAction.drawer"
                            class="icon-action-datatable"
                            text
                            :icon="headerAction.icon"
                            @click="openHeaderDrawer(headerAction)"
                            v-tooltip.bottom="headerAction.tooltip || ''"
                        />
                        <Button
                            v-else-if="headerAction.open_modal === 'document_template'"
                            :class="['icon-action-datatable', {'icon-action-datatable-image': !!headerAction.img}]"
                            text
                            :icon="headerAction.img ? null : headerAction.icon"
                            @click="openTemplateModal(headerAction.modal_is_cartella ?? 0, null, null)"
                            v-tooltip.bottom="headerAction.tooltip || ''"
                        >
                            <span v-if="headerAction.img" class="p-button-icon icon-action-datatable-image__icon">
                                <img :src="headerAction.img" class="icon-action-datatable-image__img" />
                            </span>
                        </Button>
                        <Button
                            v-else
                            as="a"
                            class="icon-action-datatable"
                            text
                            :icon="headerAction.icon"
                            :href="headerAction.href"
                            :target="headerAction.target || null"
                            v-tooltip.bottom="headerAction.tooltip || ''"
                        />
                    </template>
                    <menu-strumenti :datatable_id=datatable_id
                                    :current_route=current_route
                                    :current_params=current_params></menu-strumenti>
                </div>
                <IconField class="ricerca-search">
          <InputText v-model="searchQuery" @input="onSearchInput" :placeholder="$root.trans.cerca" class="input-cerca"/>
                    <InputIcon>
            <i :class="searchLoading ? 'pi pi-spin pi-spinner' : 'pi pi-search'"/>
                    </InputIcon>

                </IconField>
            </div>
        </template>
        <template #empty> {{ mess_vuoto }}</template>
    <template #loading></template>
        <template v-if="Object.keys(actions).length > 0">
            <Column :exportable="false" style="width: 1px; white-space: nowrap;"
                bodyStyle="text-align:center" class="icona">
                <template #body="slotProps">
                    <div class="row-actions-inline">
                        <template v-for="(action, key) in actions">
                            <template
                                v-if="key !== 'elimina' && action.form_modale !== true && (!action.condizione || (typeof action.condizione === 'string' ? slotProps.data[action.condizione] : (action.condizione === true && slotProps.data[action.condizione_key] === action.condizione_value)))">
                                <a :href="generateUrl(action, slotProps.data)"
                                   class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text  ">
                                    <i :class="'pi '+action.icona"></i>
                                </a>
                            </template>
                            <template v-if="key === 'elimina' ">
                                <a @click="rimuoviRiga(action , slotProps.data )"
                                   class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text  ">
                                    <i :class="'pi '+action.icona"></i>
                                </a>
                            </template>
                            <template
                                v-if="action.form_modale === true && (!action.condizione || (action.condizione === true && slotProps.node[action.condizione_key] === action.condizione_value))">
                                <a @click="openModal(action, slotProps.data)"
                                   class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text  ">
                                    <i :class="'pi '+action.icona"></i>
                                </a>
                            </template>
                        </template>
                    </div>
                </template>
            </Column>
        </template>
        <Column v-for="column of columns" :field="column.name"
                :header="column.title"
                sortable :filter="column.filtro !== false">
            <template #sorticon="slotProps">
                <span
                    :class="['app-dt-icon', slotProps.sorted ? (slotProps.sortOrder === 1 ? 'pi pi-sort-amount-up-alt' : 'pi pi-sort-amount-down-alt') : 'pi pi-sort-alt']"></span>
            </template>
            <template #filtericon>
                <span class="pi pi-filter app-dt-icon"></span>
            </template>
            <template #body="{data}">
                <template v-if="column.formato === 'data'">
                    {{ data[column.name] != '' && data[column.name] != null ? formatDate(data[column.name]) : '' }}
                </template>
                <template v-else-if="column.formato === 'dataora'">
                    {{ data[column.name] != '' && data[column.name] != null ? formatDateTime(data[column.name]) : '' }}
                </template>
                <template v-else-if="column.formato === 'ora_esadecimale'">
                    {{ formatTimeHexadecimal(data[column.name]) }}
                </template>
                <template v-else-if="column.formato === 'ora'">
                    {{ formatTime(data[column.name]) }}
                </template>
                <template v-else-if="column.formato === 'num_intero'">
                    {{ formatNumberInt(data[column.name]) }}
                </template>
                <template v-else-if="column.formato === 'num_decimale'">
                    {{ formatNumberDecimal(data[column.name]) }}
                </template>
                <template v-else-if="column.formato === 'prezzo'">
                    {{ formatCurrency(data[column.name]) }}
                </template>
                <template v-else-if="column.formato === 'colore'">
                    <span v-html="formatColor(data[column.name])"></span>
                </template>
                <template v-else-if="column.formato === 'componenti'">
                    <template v-for="componente in data[column.name]">
                        <component
                            :is="component(componente)"
                            v-bind="componentProps(componente)"
                        />
                    </template>
                </template>
                <template v-else-if="column.formato === 'email'">
                    <span v-html="formatEmail(data[column.name])"></span>
                </template>
                <template v-else-if="column.formato === 'luogo'">
                    <span v-html="formatLocation(data[coordinate] , data[column.name] )"></span>
                </template>
                <template v-else-if="column.formato === 'link'">
                    <span v-html="formatLink( data[column.name] )"></span>
                </template>
                <template v-else>
                    {{ data[column.name] }}
                </template>
            </template>
            <template #filter="{ filterModel }">
                <template v-if="column.formato === 'data'">
                    <DatePicker v-model="filterModel.value" dateFormat="yyyy/mm/dd" placeholder="mm/dd/yyyy"/>
                </template>
                <template v-else-if="column.formato === 'dataora'">
                    <DatePicker v-model="filterModel.value" dateFormat="yyyy/mm/dd hh:mm" placeholder="mm/dd/yyyy hh:mm"
                                showTime
                                hourFormat="24"/>
                </template>
                <template v-else-if="column.formato === 'ora_esadecimale'">
                    <DatePicker v-model="filterModel.value" dateFormat="hh:mm" placeholder="hh:mm" timeOnly
                                hourFormat="24"/>
                </template>
                <template v-else-if="column.formato === 'ora'">
                    <DatePicker v-model="filterModel.value" dateFormat="hh:mm" placeholder="hh:mm" timeOnly
                                hourFormat="24"/>
                </template>
                <template v-else-if="column.formato === 'colore'">
                    <ColorPicker v-model="filterModel.value"/>
                </template>
                <template v-else>
                    <InputText v-model="filterModel.value" type="text" :placeholder="column.title"/>
                </template>
            </template>
        </Column>

        <Dialog v-model:visible="visible" modal :header="modalForm.title" :style="{  }">
            <div v-if="modalForm.testo" class="mb-4">
                <p>{{ modalForm.testo }}</p>
            </div>
            <FormInput
                :key="modalFormKey"
                :dati="modalForm.dati"
                :formlabel="modalForm.struttura"
                :idform="modalForm.idform"
                stilestruttura=""
                recaptcha=""
                :action=modalForm.action
                ref="modalinput">
            </FormInput>
            <div class="flex justify-end gap-2 mt-4">
                <Button type="button" :label="modalForm.testoannulla" severity="secondary" @click="closeModal"></Button>
                <Button type="button" :label="modalForm.testoconferma" @click="$refs.modalinput.checkForm(0)"></Button>
            </div>
        </Dialog>
    </DataTable>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputNumber from 'primevue/inputnumber';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Tag from 'primevue/tag';
import DatePicker from 'primevue/datepicker';
import ColorPicker from 'primevue/colorpicker';
import DatatableRating from './DatatableRating.vue';
import Drawer from './Drawer.vue';
import {FilterMatchMode, FilterOperator} from '@primevue/core/api';
import {resolveComponent} from 'vue';
import {toRaw} from 'vue';
import FormInput from "./FormInput.vue";

export default {
    name: "DatatableAdvance",
    props: [
        'modulo',
        'colonne',
        'route_righe',
        'azioni',
        'add_action',
        'current_route',
        'current_params',
        'datatable_id',
        'mess_vuoto',
        'mess_caricamento',
        'route_params',
        'header_actions',
        'use_paginator',
        'paginator_threshold',
        'paginator_rows',
        'datatable_size',
        'scroll_height'],
    components: {
        FormInput,
        DataTable,
        Column,
        InputNumber,
        Dialog,
        InputText,
        InputIcon,
        IconField,
        Button,
        DatePicker,
        ColorPicker,
        Tag,
        DatatableRating,
        Drawer,
    },
    data() {
        return {
            filters: {},
            loading: true,
            rows: [],
            columns: this.colonne,
            actions: this.azioni || null,
            datatable_id: this.datatable_id || null,
            current_route: this.current_route || null,
            current_params: this.current_params || null,
            routeParamsInternal: this.route_params || null,
            headerActions: this.header_actions || [],
            showHeaderDrawer: false,
            headerDrawerTitle: '',
            headerDrawerHtml: '',
            headerDrawerLoading: false,
            lastHeaderDrawerAction: null,
            templateModalVisible: false,
            templateModalIsCartella: false,
            templateModalParentId: null,
            templateModalId: null,
            templateModalNome: '',
            templateModalNote: '',
            templateModalFile: null,
            templateModalLoading: false,
            templateModalTitle: '',
            templateModalCartelle: [],
            templateModalForm: {},
            templateModalFormKey: 0,
            templateModalSubmitting: false,
            deleteTemplateModalVisible: false,
            deleteTemplateModalIsCartella: false,
            deleteTemplateModalChildrenCount: 0,
            deleteTemplateModalId: null,
            deleteTemplateModalLoading: false,
            modalForm: {
                title: '',
                struttura: null,
                idform: '',
                dati: {},
                testoannulla: 'Annulla',
                testoconferma: 'Conferma'
            },
            globalfilters: [],
            currentAction: null,
            currentRows: null,
            searchQuery: '',
            searchLoading: false,
            searchTimeout: null,
        }
    },
    computed: {
        paginatorRows() {
            return this.paginator_rows || 20;
        },
        datatableSize() {
            return this.datatable_size === undefined ? 'small' : this.datatable_size;
        },
        paginatorEnabled() {
            if (!this.use_paginator) return false;
            if (this.paginator_threshold === undefined || this.paginator_threshold === null) return true;
            return this.rows.length > this.paginator_threshold;
        },
        stateKey() {
            const modulo = this.modulo || route().current();
            if (this.paginator_rows && this.paginator_rows !== 20) {
                return `${modulo}-${this.paginator_rows}-session`;
            }
            return `${modulo}-session`;
        }
    },
    async beforeCreate() {
		this.loading = true;
        const righe = await axios.get(route(this.route_righe, this.route_params));
        if (righe.status === 200) {
            this.rows = righe.data;
			if (this.is_lazy && righe.data.total) {
				this.total = righe.data.total ?? 0;
			}
			this.loading = false;
        } else {
            // Qui ci sarebbe da gestire l'errore se la chiamata non va a buon fine
            this.rows = [];
			this.loading = false;
        }
    },
    async created() {
        this.initFilters();
        this.globalfilters = this.columns
            .filter(column => column.filtro !== false)
            .map(column => column.name);

    },
    async mounted() {
   // this.loading = false;
        const toastMessage = JSON.parse(sessionStorage.getItem('toastMessage'));
        if (toastMessage) {

            this.$toast.add({
                severity: toastMessage.severity,
                summary: toastMessage.summary,
                detail: toastMessage.detail,
                life: 3000,
            });
            sessionStorage.removeItem('toastMessage');
        }
        this._loadRowsHandler = () => {
            this.loadRows();
            if (this.templateModalVisible) {
                this.templateModalVisible = false;
                this.templateModalSubmitting = false;
                if (this.lastHeaderDrawerAction) {
                    this.openHeaderDrawer(this.lastHeaderDrawerAction);
                }
            }
        };
        document.addEventListener('form-saved-success', this._loadRowsHandler);
        this._formSubmitStateHandler = (e) => {
            const detail = e?.detail || {};
            if (detail.idform !== 'template-modal-form') return;
            this.templateModalSubmitting = detail.status === 'start';
        };
        document.addEventListener('form-submit-state', this._formSubmitStateHandler);
        this._paramsChangedHandler = (e) => {
            const detail = e?.detail || {};
            if (!detail.datatable_id || detail.datatable_id !== this.datatable_id) return;
            this.routeParamsInternal = detail.route_params || {};
            this.loadRows();
        };
        document.addEventListener('datatable-params-changed', this._paramsChangedHandler);
        window.openDocumentTemplateModal = (isCartella, parentId, id) => {
            this.openTemplateModal(isCartella, parentId, id);
        };
        window.openDeleteTemplateModal = (id, isCartella, childrenCount) => {
            this.deleteTemplateModalId = id;
            this.deleteTemplateModalIsCartella = !!isCartella;
            this.deleteTemplateModalChildrenCount = childrenCount || 0;
            this.deleteTemplateModalVisible = true;
        };
    },
    beforeUnmount() {
        document.removeEventListener('form-saved-success', this._loadRowsHandler);
        document.removeEventListener('form-submit-state', this._formSubmitStateHandler);
        document.removeEventListener('datatable-params-changed', this._paramsChangedHandler);
        delete window.openDocumentTemplateModal;
    },
    methods: {
        async openHeaderDrawer(action) {
            this.headerDrawerTitle = action.drawer_title || action.tooltip || '';
            this.headerDrawerHtml = '';
            this.headerDrawerLoading = true;
            this.showHeaderDrawer = true;
            this.lastHeaderDrawerAction = action;

            try {
                const response = await axios.get(action.href);
                this.headerDrawerHtml = response.data;
            } catch (error) {
                this.headerDrawerHtml = '<div class="p-4 text-sm text-red-600">Errore nel caricamento del contenuto.</div>';
            } finally {
                this.headerDrawerLoading = false;
            }
        },
        async openTemplateModal(isCartella, parentId, id) {
            this.templateModalIsCartella = !!isCartella;
            this.templateModalTitle = isCartella ? 'Aggiungi cartella' : 'Aggiungi documento';
            this.templateModalForm = {};
            this.templateModalVisible = true;

            try {
                const params = { is_cartella: isCartella ? 1 : 0 };
                if (parentId) params.parent_template_id = parentId;
                if (id) params.id = id;
                const res = await axios.get(route('automezzi/documenti-comuni/modal-form'), { params });
                this.templateModalForm = res.data;
                this.templateModalFormKey++;
            } catch (e) {
                console.error('Errore caricamento form template:', e);
                this.templateModalVisible = false;
            }
        },
        closeTemplateModal() {
            this.templateModalVisible = false;
            this.templateModalSubmitting = false;
        },
        async confirmDeleteTemplate() {
            this.deleteTemplateModalLoading = true;
            try {
                await axios.post(route('automezzi/impostazioni/documenti-template/elimina'), {
                    id: this.deleteTemplateModalId,
                    _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                });
                this.deleteTemplateModalVisible = false;
                if (this.lastHeaderDrawerAction) {
                    await this.openHeaderDrawer(this.lastHeaderDrawerAction);
                }
            } catch (e) {
                console.error('Errore eliminazione template:', e);
            } finally {
                this.deleteTemplateModalLoading = false;
            }
        },
        async loadRows() {
            const params = this.routeParamsInternal ?? this.route_params;
            const righe = await axios.get(route(this.route_righe, params));
            if (righe.status === 200) {
                this.rows = righe.data;
            }
        },
        async openModal(action, rows) {
            this.currentAction = action;
            this.currentRows = rows;
            this.visible = true;
            try {
                if (action.form_route) {
                    const params = action.form_params.reduce((acc, param) => {
                        acc[param] = rows[param];
                        return acc;
                    }, {});

                    const formUrl = route(action.form_route, params);
                    const response = await axios.get(formUrl);

                    if (response.status === 200) {
                        this.modalForm = response.data;
                        this.modalFormKey++;
                    }
                } else if (action.form) {
                    this.modalForm = action.form;
                }
            } catch (error) {
                console.error('Errore nel caricamento del form:', error);
                this.closeModal();
            }
        },
        closeModal() {
            this.visible = false;
            this.modalForm = {
                title: '',
                struttura: null,
                idform: '',
                dati: {},
                testoannulla: 'Annulla',
                testoconferma: 'Conferma'
            };
            this.currentAction = null;
            this.currentRows = null;
        },
        formatDate(value) {
            return new Date(value).toLocaleDateString('it-IT', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        },
        handleHeaderAction(action) {
            if (action.url) {
                window.location.href = route(action.url, action.parametri);
            }
        },
        formatDateTime(value) {
            const date = new Date(value).toLocaleDateString('it-IT', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
            const time = new Date(value).toLocaleTimeString('it-IT', {
                hour: '2-digit',
                minute: '2-digit'
            });
            return date + " " + time;
        },
        formatTimeHexadecimal(value) {
            const timeString = `1970-01-01T${value}`; // Adding a dummy date
            return new Date(timeString).toLocaleTimeString('it-IT', {
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        formatTime(value) {
            const hours = Math.floor(value);
            const minutes = Math.floor((value - hours) * 60);
            console.log('$root.trans');
            console.log(this.$root.trans);
            if (hours > 0) {
                return `${value}: ${hours} ${this.$root.trans.ore} ${minutes} ${this.$root.trans.minuti}`
            }
            return `${value}: ${minutes} ${this.$root.trans.minuti}`

        },
        formatCurrency(value) {
            return value.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
        },
        formatNumberInt(value) {
            return value.toLocaleString("it-IT", {minimumFractionDigits: 0, maximumFractionDigits: 0});
        },
        formatNumberDecimal(value) {
            return value.toLocaleString("it-IT", {minimumFractionDigits: 2, maximumFractionDigits: 2});
        },
        formatColor(value) {
            return '<i class="pi pi-circle-fill" style="color:' + value + '">';
        },
        formatEmail(value) {
            return `<a href="mailto:${value}">${value}</a>`;
        },
        formatLink(value) {
            return `<a href="${value}"><i class="pi pi-file-export"></i></a>`;
        },
        formatLocation(coordinate, indirizzo) {
            return coordinate ? `<a href="https://www.google.com/maps?q=${coordinate}"  target="_blank" rel="noopener noreferrer">${indirizzo}</a>` : indirizzo;
        },
        onSearchInput() {
            this.searchLoading = true;
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.filters['global'].value = this.searchQuery;
                this.searchLoading = false;
            }, 400);
        },
        clearFilter() {
            this.searchQuery = '';
            this.initFilters();
        },
        initFilters() {
            this.filters['global'] = {value: null, matchMode: FilterMatchMode.CONTAINS};
            this.columns.forEach(column => {
                if (column.formato === 'data') {
                    this.filters[column.name] = {
                        operator: FilterOperator.AND,
                        constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]
                    }
                } else if (column.formato === 'dataora') {
                    this.filters[column.name] = {
                        operator: FilterOperator.AND,
                        constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]
                    }
                } else if (column.formato === 'ora') {
                    this.filters[column.name] = {
                        operator: FilterOperator.AND,
                        constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]
                    }
                } else if (column.formato === 'colore') {
                    this.filters[column.name] = {
                        operator: FilterOperator.AND,
                        constraints: [{value: null, matchMode: 'equals'}]
                    }
                } else {
                    this.filters[column.name] = {
                        operator: FilterOperator.AND,
                        constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
                    }
                }
            });
        },
        generateUrl(action, rowData) {
            console.log("RowData:", rowData);
            const params = action.parametri.reduce((acc, param) => {
                acc[param] = rowData[param];
                return acc;
            }, {});

            console.log(params);
            // Genera il link usando una funzione fittizia `route` (sostituisci con il tuo sistema di routing)
            return route(action.url, params);
        },
        component(name) {
            return resolveComponent(name.component);
        },
        componentProps(name) {
            const rawProps = toRaw(name.props ?? {});
            for (const [key, value] of Object.entries(rawProps?.functions ?? {})) {
                rawProps[key] = new Function(value);
            }
            return rawProps;
        },
        rimuoviRiga: async function (action, elemento) {
            if (action.condizione === true && elemento[action.condizione_key] !== action.condizione_value) {
                alert(`${this.$root.trans.impossibile_eliminare} ${elemento.nome ?? ` ${this.$root.trans.l_elemento_selezionato}`}: ${this.$root.trans.tipologia_con_sottotipi_o_ticket}`)
                return
            }
            if (confirm(`${this.$root.trans.eliminare} ${elemento.nome ?? ` ${this.$root.trans.l_elemento_selezionato}`} ?`)) {
                const params = action.parametri.reduce((acc, param) => {
                    acc[param] = elemento[param];
                    return acc;
                }, {});
                const response = await axios.post(route(action.url, params));
                if (response.status == 200) {
                    this.rows.splice(this.rows.indexOf(elemento), 1);
                    this.$toast.add({
                        severity: 'success',
                        summary: `${elemento.nome ?? this.$root.trans.elemento} ${this.$root.trans.eliminato}`,
                        detail: `${elemento.nome ?? this.$root.trans.elemento} ${this.$root.trans.eliminato} ${this.$root.trans.correttamente}`,
                        life: 3000
                    })
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: `${response.status}`,
                        detail: `${this.$root.trans.elemento}: ${elemento.nome ?? this.$root.trans.elemento} `,
                        life: 3000
                    })
                }
            }
        }
    }
}

</script>


<style scoped>

</style>
